class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      this.onCartUpdate();
    });
  
    // 🎯 Gestisci TUTTE le checkbox gift-wrapping (es. cart e mini cart)
    document.querySelectorAll('input[name="attributes[gift-wrapping]"]').forEach((checkbox) => {
      if (!checkbox.dataset.listenerAttached) {
        checkbox.addEventListener('change', () => {
          this.toggleGiftWrap(checkbox.checked);
        });
        checkbox.dataset.listenerAttached = true;
      }
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';
    if (event.target.type === 'checkbox') return;

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

    onCartUpdate() {
      const rebindGiftWrapListeners = () => {
        document.querySelectorAll('input[name="attributes[gift-wrapping]"]').forEach((checkbox) => {
          if (!checkbox.dataset.listenerAttached) {
            checkbox.addEventListener('change', () => {
              this.toggleGiftWrap(checkbox.checked);
            });
            checkbox.dataset.listenerAttached = true;
          }
        });
      };
    
      const updateSection = (sectionId, selector) => {
        fetch(`${routes.cart_url}?section_id=${sectionId}`)
          .then((res) => res.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newContent = html.querySelector(selector);
            const target = document.querySelector(selector);
            if (newContent && target) {
              target.replaceWith(newContent);
            }
            rebindGiftWrapListeners();
          });
      };
    
      if (document.querySelector('cart-drawer-items')) {
        updateSection('cart-drawer', 'cart-drawer-items');
        updateSection('cart-drawer', '.cart-drawer__footer');
      }
    
      if (document.querySelector('cart-items')) {
        updateSection('main-cart-items', 'cart-items');
        updateSection('main-cart-footer', '#main-cart-footer .js-contents');
      }

      if (document.querySelector('#main-cart-message')) {
        updateSection('#main-cart-message');
      }
    }
    
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
       {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
       },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-message',
        section: document.getElementById('main-cart-message').dataset.id,
        selector: '#main-cart-message .js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
  
    fetch(`${routes.cart_url}.json`)
      .then(res => res.json())
      .then(cart => {
        let profumoCount = 0;
        const currentLineItem = cart.items[line - 1];
  
        cart.items.forEach((item, index) => {
          const isProfumo = item.properties && item.properties._tag_profumo === 'true';
          const itemQty = (index === line - 1) ? quantity : item.quantity;
          if (isProfumo) profumoCount += itemQty;
        });
    
        if (profumoCount > 8) {
          const errorMessage = window.cartStrings.quantityErrorProf;
          this.updateLiveRegions(line, errorMessage);
          this.disableLoading(line);
  
          const quantityInput = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          quantityInput.value = currentLineItem.quantity;

          return;
        }
        if (name === undefined) {
          document.dispatchEvent(new CustomEvent('product:removed', { detail: { line } }));
        }
        // ✅ Procedi con il cambio quantità
        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });
  
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);
            const quantityElement =
              document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            const items = document.querySelectorAll('.cart-item');
  
            if (parsedState.errors) {
              quantityElement.value = quantityElement.getAttribute('value');
              this.updateLiveRegions(line, parsedState.errors);

              return;
            }
  
            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');
  
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
  
            const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
            let message = '';
            if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
              if (typeof updatedValue === 'undefined') {
                message = window.cartStrings.error;
              } else {
                message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
              }
            }
  
            this.updateLiveRegions(line, message);
  
            const lineItem =
              document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
              trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
            }
            
            if (name === 'plus') {
              document.dispatchEvent(new CustomEvent('product:addedDrawer', { detail: { line } }));
            } else if (name === 'minus') {
              document.dispatchEvent(new CustomEvent('product:removedDrawer', { detail: { line } }));
            }
  
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
          })
          .catch(() => {
            this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            errors.textContent = window.cartStrings.error;
          })
          .finally(() => {
            this.disableLoading(line);
            document.dispatchEvent(new Event('cart-quantity-update'));
  
            fetch(`${routes.cart_url}.json`)
              .then(res => res.json())
              .then(cart => {
                const giftWrapVariantId = window.giftWrapVariantId;
                const giftWrapItem = cart.items.find(item => item.variant_id === giftWrapVariantId);
                const onlyGiftWrap = cart.items.length === 1 && giftWrapItem;
  
                if (onlyGiftWrap) {
                  const giftWrapIndex = cart.items.findIndex(item => item.variant_id === giftWrapVariantId);
                  const removeButtons = document.querySelectorAll('cart-remove-button');
  
                  removeButtons.forEach(button => {
                    if (parseInt(button.dataset.index) === giftWrapIndex + 1) {
                      button.click(); // simula click
                    }
                  });
  
                  return;
                }
  
                if (!giftWrapItem) {
                  document.querySelectorAll('input[name="attributes[gift-wrapping]"]').forEach(cb => {
                    cb.checked = false;
                  });
                }
              });
          });
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');
    mainCartItems.classList.add('cart-freeze'); 
  
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
      mainCartItems.classList.remove('cart-freeze');


    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  toggleGiftWrap(add) {
    document.querySelectorAll('input[name="attributes[gift-wrapping]"]').forEach(cb => {
      cb.checked = add;
    });

    const giftWrapVariantId = window.giftWrapVariantId;
    const giftWrapPropertyName = '_giftwrap_message';
    const message = 'Gift Wrapped';
    const sections = this.getSectionsToRender().map(section => section.section);
    
    fetch(`${routes.cart_url}.json`)
      .then(res => res.json())
      .then(data => {
        const giftWrapItem = data.items.find(i => i.variant_id === giftWrapVariantId);
        const giftWrapLine = data.items.findIndex(i => i.variant_id === giftWrapVariantId) + 1;
  
        if (add) {
          if (giftWrapItem) {
            return;
          }
  
          const body = JSON.stringify({
            items: [{
              id: giftWrapVariantId,
              quantity: 1,
              properties: { [giftWrapPropertyName]: message }
            }],
            sections,
            sections_url: window.location.pathname
          });
  
          return fetch(routes.cart_add_url, { ...fetchConfig(), body })
            .then(res => res.text())
            .then(() => this.onCartUpdate());
  
        } else {
          if (giftWrapLine > 0) {
            const body = JSON.stringify({
              line: giftWrapLine,
              quantity: 0,
              sections,
              sections_url: window.location.pathname
            });
  
            return fetch(routes.cart_change_url, { ...fetchConfig(), body })
              .then(res => res.text())
              .then(() => this.onCartUpdate());
          } else {
            console.warn('[GiftWrap] Tried to remove but gift not found in cart');
          }
        }
      });
  }

}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
